import React from 'react';
import { Toaster } from 'sonner';
import { Header } from './components/layout/Header';
import { HeroSection } from './components/sections/HeroSection';
import { ShowroomSection } from './components/sections/ShowroomSection';
import { AdvantageSection } from './components/sections/AdvantageSection';
import { StoneTypesSection } from './components/sections/StoneTypesSection';
import { ProjectsSection } from './components/sections/ProjectsSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { ProcessSection } from './components/sections/ProcessSection';
import { FinalCtaSection } from './components/sections/FinalCtaSection';
export function App() {
  return <div className="w-full min-h-full bg-white" data-id="element-0" data-mp="2wiyx2s8zrtbo">
      <Toaster position="top-center" richColors data-id="element-1" data-mp="2wi5nljineppu" />
      <Header data-id="element-2" data-mp="28te2td7e19n3" />
      <main data-id="element-3" data-mp="28suu8n3mnxlq">
        <HeroSection data-id="element-4" data-mp="28sl5f2ubjwhm" />
        <ShowroomSection data-id="element-5" data-mp="23vciyq2516ak" />
        <AdvantageSection data-id="element-6" data-mp="23vul23bheeqe" />
        <StoneTypesSection data-id="element-7" data-mp="23ujl6el5pr4k" />
        <ProjectsSection data-id="element-8" data-mp="23t8h0dnsuhcx" />
        <TestimonialsSection data-id="element-9" data-mp="3ik7eyd5x05p2" />
        <ProcessSection data-id="element-10" data-mp="3iiwg8rrbto4t" />
        <FinalCtaSection data-id="element-11" data-mp="3ijpd910hgz9r" />
      </main>
    </div>;
}